import { clsx } from 'clsx';
import { FC } from 'react';
import { CTA } from 'atoms/Typography/Typography';
import { ActionButton } from 'molecules/Header';
import { SizeButton } from 'molecules/SelectSizeButtons/SizeButton';
import { useProductSizeSort } from 'pages/ProductDetail/hooks/useProductSizeSort';
import { useTranslations } from 'modules/i18n/useTranslations';
import { IProductSize } from 'commerce/scayle/utils/adapter/types';
import styles from './SelectSizeButtons.module.css';

const PDPHeader: FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const t = useTranslations();
  return (
    <div className={styles.pdpHeader}>
      <ActionButton
        text={t('product.pdp.footer.button-sizes')}
        classes={{
          root: styles.backButton,
          icon: styles.backIcon,
          text: styles.backText,
        }}
        action={onClose}
      />
    </div>
  );
};

const DefaultHeader: FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const t = useTranslations();
  return (
    <div className={styles.sizeSelectHeader}>
      <ActionButton
        text={t('product.pdp.footer.back')}
        classes={{
          root: styles.backButton,
        }}
        action={onClose}
      />
      <CTA type="lg"> {t('product.pdp.footer.title')}</CTA>
    </div>
  );
};
export const SelectSizeButtons: FC<{
  sizes: IProductSize[];
  onClick: (size: IProductSize) => void;
  onClose: () => void;
  open: boolean;
  selectedVariant?: string;
  desktopSize?: boolean;
  isPDP?: boolean;
  classes?: {
    wrapper?: string;
    button?: string;
  };
}> = ({
  open,
  onClose,
  sizes,
  selectedVariant,
  desktopSize,
  onClick,
  isPDP,
  classes,
}) => {
  const { sizeSort } = useProductSizeSort();

  const sortedSizes = sizes.sort(sizeSort);

  return (
    <div
      className={clsx(
        styles.sizeSelectWrapper,
        open && styles.sizeSelectOpen,
        desktopSize && styles.desktopSize,
        classes?.wrapper,
      )}
    >
      {open && (
        <>
          {isPDP ? (
            <PDPHeader onClose={onClose} />
          ) : (
            <DefaultHeader onClose={onClose} />
          )}
          <div className={styles.sizeSelectContainer}>
            <div className={styles.sizeSelect}>
              {sortedSizes.map((size) => (
                <SizeButton
                  key={size.id}
                  size={size}
                  disabled={size.stock <= 0}
                  selected={selectedVariant === size.referenceKey}
                  className={clsx(
                    styles.sizeSelectButton,
                    classes?.button,
                    selectedVariant === size.referenceKey &&
                      styles.sizeButtonSelected,
                  )}
                  onClick={() => onClick(size)}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
